module.exports = __webpack_public_path__ + "36b3750db8655c2bec0f14e0296a67bb.png";